import { render, staticRenderFns } from "./reporterType.vue?vue&type=template&id=48e8a206&scoped=true"
import script from "./reporterType.vue?vue&type=script&lang=js"
export * from "./reporterType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e8a206",
  null
  
)

export default component.exports